import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SidebarTooltipDirective } from '../shell/sidebar-tooltip.directive';
import { RoleGateComponent } from '../shared/authz/role-gate.component';
import { ROLE_GROUPS } from '../shared/authz/role-groups';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'of-orders-nav-menu',
  imports: [RoleGateComponent, RouterLink, RouterLinkActive, SidebarTooltipDirective],
  template: `
    <of-role-gate [includeRoles]="roleGroups.viewOrders">
      <div id="sidebar-nav" class="list-group text-sm-start">
        <a
          class="list-group-item border-0 mb-1 p-1"
          [routerLink]="['/orders']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          ofSidebarTooltip="List"
          ><i class="bi bi-list-ul me-2"></i><span>List</span></a
        >
      </div>
      <div id="sidebar-nav" class="list-group text-sm-start">
        <a
          class="list-group-item border-0 mb-1 p-1"
          [routerLink]="['/orders']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          [queryParams]="{ lucianosOrders: true }"
          ofSidebarTooltip="Luciano's List"
          ><i class="bi bi-funnel me-2"></i><span>Luciano's List</span></a
        >
      </div>
      <div id="sidebar-nav" class="list-group text-sm-start">
        <a
          class="list-group-item border-0 mb-1 p-1"
          [routerLink]="['/orders']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          [queryParams]="{ gtcgtdOrders: true }"
          ofSidebarTooltip="GTC / GTD List"
          ><i class="bi bi-clock me-2"></i><span>GTC / GTD List</span></a
        >
      </div>
      <div id="sidebar-nav" class="list-group text-sm-start">
        <a
          class="list-group-item border-0 mb-1 p-1"
          [routerLink]="['/orders', 'emsx-orders']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: false }"
          ofSidebarTooltip="EMSX Orders"
          ><i class="bi bi-send me-2"></i><span>EMSX Orders</span></a
        >
      </div>
    </of-role-gate>
    <of-role-gate [includeRoles]="roleGroups.orderWrite">
      <div id="sidebar-nav" class="list-group text-sm-start">
        <a
          class="list-group-item border-0 mb-1 p-1"
          [routerLink]="['/orders', 'create']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: false }"
          ofSidebarTooltip="New Order"
          ><i class="bi bi-file-earmark-plus me-2"></i><span>New</span></a
        >
      </div>
      <div id="sidebar-nav" class="list-group text-sm-start">
        <a
          class="list-group-item border-0 mb-1 p-1"
          [routerLink]="['/orders', 'bulk-upload']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: false }"
          ofSidebarTooltip="Bulk Upload"
          ><i class="bi bi-cloud-arrow-up me-2"></i><span>Bulk Upload</span></a
        >
      </div>
    </of-role-gate>
    <of-role-gate [includeRoles]="roleGroups.orderCreateFx">
      <div id="sidebar-nav" class="list-group text-sm-start">
        <a
          class="list-group-item border-0 mb-1 p-1"
          [routerLink]="['/orders', 'create-fx']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: false }"
          ofSidebarTooltip="New FX"
          ><i class="bi bi-currency-exchange me-2"></i><span>New FX</span></a
        >
      </div>
      <div id="sidebar-nav" class="list-group text-sm-start">
        <a
          class="list-group-item border-0 mb-1 p-1"
          [routerLink]="['/orders', 'fx-bulk-upload']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: false }"
          ofSidebarTooltip="FX Bulk Upload"
          ><i class="bi bi-cloud-arrow-up me-2"></i><span>FX Bulk Upload</span></a
        >
      </div>
    </of-role-gate>
    <of-role-gate [includeRoles]="roleGroups.orderReadWrite">
      <div id="sidebar-nav" class="list-group text-sm-start">
        <a
          class="list-group-item border-0 mb-1 p-1"
          [routerLink]="['/time-deposits']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: false }"
          ofSidebarTooltip="Time Deposits"
          ><i class="bi bi-calendar-check me-2"></i><span>Time Deposits</span></a
        >
      </div>
    </of-role-gate>
    <of-role-gate [includeRoles]="roleGroups.partialExecutionsView">
      <div id="sidebar-nav" class="list-group text-sm-start">
        <a
          class="list-group-item border-0 mb-1 p-1"
          [routerLink]="['/partial-executions']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: false }"
          ofSidebarTooltip="Order Executions"
          ><i class="bi bi-receipt-cutoff me-2"></i><span>Order Executions</span></a
        >
      </div>
    </of-role-gate>
    <of-role-gate [includeRoles]="roleGroups.partialExecutionsReaderOnly" [excludeRoles]="roleGroups.orderReadWrite">
      <div id="sidebar-nav" class="list-group text-sm-start">
        <a
          class="list-group-item border-0 mb-1 p-1"
          [routerLink]="['/partial-executions']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: false }"
          ofSidebarTooltip="Order Executions"
          ><i class="bi bi-receipt-cutoff me-2"></i><span>Order Executions</span></a
        >
      </div>
    </of-role-gate>
    <of-role-gate [includeRoles]="roleGroups.tradeRestrictionsView">
      <div id="sidebar-nav" class="list-group text-sm-start">
        <a
          class="list-group-item border-0 mb-1 p-1"
          [routerLink]="['/trade-restrictions']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: false }"
          ofSidebarTooltip="Trade Restrictions"
          ><i class="bi bi-shield-exclamation me-2"></i><span>Trade Restrictions</span></a
        >
      </div>
    </of-role-gate>
  `
})
export class OrdersNavMenuComponent {
  protected readonly roleGroups = ROLE_GROUPS;
}
